import * as yup from "yup";
export const validationSchema = yup.object().shape({
  name: yup
    .string()
    .max(50, "Name cannot be greater than 50 character")
    .required("Name is required"),
  appearance: yup
    .string()
    .max(300, "Appearance cannot be graeter than 300 characters")
    .required("Appearance is required"),
  typical_clothing: yup
    .string()
    .max(300, "Clothing cannot be graeter than 300 characters")
    .required("Clothing is required"),
  typical_expression: yup
    .string()
    .max(300, "Expression cannot be graeter than 300 characters"),
});
